var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ak-panel ak-panel--no-padding m-b-xs-20" }, [
    _c("div", { staticClass: "ak-panel__header ak-panel__header--small" }, [
      _c("div", { staticClass: "ak-panel__title" }, [
        _c("i", { staticClass: "fa fa-list" }),
        _vm._v(
          "\n            " +
            _vm._s(_vm.$t("Te behandelen kandidaat-partners")) +
            "\n        "
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ak-panel__body ak-panel__body--small reading" }, [
      _c("div", { staticClass: "ak-data-table__table table-candidates" }, [
        _vm.candidates.length
          ? _c(
              "table",
              { staticClass: "ak-table ak-table--compact ak-panel__table" },
              [
                _c("thead", [
                  _c("tr", { staticClass: "ak-table-row ak-table" }, [
                    _c(
                      "th",
                      { staticClass: "ak-table-head table-head th-sticky" },
                      [_c("span", [_vm._v(_vm._s(_vm.$t("Datum aanvraag")))])]
                    ),
                    _vm._v(" "),
                    _c("th", { staticClass: "ak-table-head th-sticky" }, [
                      _c("span", [_vm._v(_vm._s(_vm.$t("Naam")))]),
                    ]),
                    _vm._v(" "),
                    _c("th", { staticClass: "ak-table-head th-sticky" }, [
                      _c("span", [_vm._v(_vm._s(_vm.$t("Locatie")))]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  { staticClass: "ak-table-body" },
                  _vm._l(_vm.candidates, function (request, index) {
                    return _c(
                      "tr",
                      { key: index, staticClass: "ak-table-row" },
                      [
                        request.status === 0
                          ? _c("td", { staticClass: "ak-table-column" }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm._f("date")(request.dateRequest))
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        request.status === 0
                          ? _c(
                              "td",
                              { staticClass: "ak-table-column" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "text-decoration-none",
                                    attrs: {
                                      to: {
                                        name: "supplier-candidate-overview",
                                        params: { hashId: request.hashId },
                                      },
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(request.companyName)),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        request.status === 0
                          ? _c("td", { staticClass: "ak-table-column" }, [
                              _c("span", [_vm._v(_vm._s(request.location))]),
                            ])
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                ),
              ]
            )
          : _c("div", [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("Geen nieuwe aanvragen")) +
                  "\n            "
              ),
            ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }